


function Section1() {
  return (
    <>
        {/* <div className='relative w-10/12 -top-20 left-60  '>
            <img src='imgs/food5.jpg' className='relative shadow-[-8px_10px_4px_rgba(249,201,130)]' alt='image'/>
        </div>  */}

        <div className='relative w-32 tablet:w-10/12 left-40 tablet:left-60 -top-20 '>
            <img src='imgs/food5.jpg' className=' relative shadow-[-8px_10px_4px_rgba(249,201,130)]' alt='image'/>
        </div> 

        <div className='w-full grid grid-cols-1'>
            <span className='h-3 w-full bg-primary my-5'></span>
            <span className='h-3 w-4/5 bg-primary'></span>
        </div>
        


        <h3 className='text-center text-primary py-8 text-2xl tablet:text-5xl'>Our Story</h3>
    </>
  )
}

export default Section1